module.exports = __webpack_public_path__ + "static/media/priceImage3.ea57b96c.svg";